var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuPontos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_132",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11350",
    "data-name": "Grupo 11350",
    transform: "translate(8.645 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2024",
    "data-name": "Grupo 2024"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.64, -6)",
    filter: "url(#Elipse_132)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_132-2",
    "data-name": "Elipse 132",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(9 6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "tres-pontos",
    transform: "translate(18.214 7.939) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9374",
    "data-name": "Caminho 9374",
    d: "M1.981,0A2.046,2.046,0,0,0,0,2.107,2.045,2.045,0,0,0,1.981,4.214,2.046,2.046,0,0,0,3.96,2.107,2.046,2.046,0,0,0,1.981,0ZM8.1,0A2.047,2.047,0,0,0,6.122,2.106,2.047,2.047,0,0,0,8.1,4.214a2.047,2.047,0,0,0,1.982-2.107A2.048,2.048,0,0,0,8.1,0Zm5.918,0A2.047,2.047,0,0,0,12.04,2.107a1.984,1.984,0,1,0,3.96,0A2.046,2.046,0,0,0,14.021,0Z",
    fill: "#123f6e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPontos);
export default __webpack_public_path__ + "static/media/menuPontos.d1777960ed7ab4b14e7b37ed5b815c77.svg";
export { ForwardRef as ReactComponent };